module.exports = __webpack_public_path__ + "static/img/bg_slices.74a9987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_slices.png
// module id = 6pdX
// module chunks = 1